import { useCallback, useState } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useSupplierOfferStarMutation } from 'api';
import { useNavigate, useParams } from 'react-router-dom';

export const useSupplierOfferCard = () => {
  const [recordId, setRecordId] = useState<string | undefined>();
  const [deleteModalState, setDeleteModalState] = useState<boolean>(false);
  const [publishModalState, setPublishModalState] = useState<boolean>(false);
  const { handleSuccess, handleError } = useNotificationMessages();
  const [updateStar] = useSupplierOfferStarMutation();
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };

  const handleStarChange = useCallback(
    async (supplierOfferId: string | undefined) => {
      if (supplierOfferId) {
        try {
          const response = await updateStar(supplierOfferId);
          if (response?.data?.success) {
            handleSuccess('Star was successfully updated');
          } else {
            handleError(response.error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [handleError, handleSuccess, updateStar]
  );

  const onPublish = useCallback((recordId?: string) => {
    setPublishModalState((oState) => !oState);
    setRecordId(recordId);
  }, []);
  const onDelete = useCallback((recordId?: string) => {
    setDeleteModalState((oState) => !oState);
    setRecordId(recordId);
  }, []);
  return {
    handleStarChange,
    recordId,
    navigate,
    onPublish,
    publishModalState,
    deleteModalState,
    onDelete,
    id,
  };
};
